import React from "react";
import "./roundedButton.css";

export default function RoundedButton({
  label,
  color = "",
  size = "",
  onClick,
  disabled = false,
  type = "",
  dataTestID = "",
}) {
  return (
    <button
      className={`rounded-button ${color} ${size}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
      data-testid={dataTestID}
    >
      {label}
    </button>
  );
}
